<template>
  <!-- 员工管理 -->
  <div class="wrapper">
    <div class="container">
      <div class="left">
        <SelectDept v-model="searchData.deptId"></SelectDept>
        <div class="tree">
          <el-tree
              ref="tree"
              node-key="id"
              highlight-current
              :data="treeData"
              :props="defaultProps"
              :expand-on-click-node="false"
              :default-expand-all="true"
              @node-click="handleNodeClick"
          ></el-tree>
        </div>
      </div>
      <div class="right">
        <div class="header-search">
          <el-form ref="form" inline label-width="100px">
            <el-form-item label="员工姓名">
              <el-input style="width:250px" v-model="searchData.userName" size="small" placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label="手机号">
              <el-input style="width:250px" v-model="searchData.mobile" size="small" placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label=" ">
              <el-button type="primary" size="small" @click="getAdminList">搜索</el-button>
              <el-button type="info" size="small" @click="reset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>

        <el-divider></el-divider>

        <el-button
            v-checkbtn="isShowBtn(AUTH_BTN.user_list_add)"
            style="margin-bottom:20px;"
            type="primary"
            size="small"
            @click="showAddOrEdit = true;rowId = null;"
        >新增</el-button
        >

        <tp-table
            :isNeedSerialNumber="false"
            :tableData="list"
            :columns="columns"
            :totalNum="total"
            :current-page.sync="currentPage"
            :pageSize.sync="pageSize"
        />
      </div>
    </div>

    <!-- 新增&编辑 -->
    <AddOrEdit
        v-if="showAddOrEdit"
        :rowId="rowId"
        :showAddOrEdit="showAddOrEdit"
        @closeDialog="closeDialogFun"
    />
  </div>
</template>

<script>
import SelectRole from '@/views/components/select-role.vue';
import SelectDept from '@/views/components/select-dept.vue';
import { getAdminList, removeAdmin, getRoleList, changeStatus, getDeptTree } from './api';
import { authBtnMixin } from '@/mixins/authBtnMixin';
import AddOrEdit from "./add-edit.vue";

const columns = [
  {
    label: 'ID',
    prop: 'id',
    minWidth: '100',
    customRender(h, row) {
      return <div>{row['id']}</div>
    }
  },
  {
    label: '员工姓名',
    prop: 'userName',
    minWidth: '120',
    customRender(h, row) {
      return <div>{row['userName']}</div>
    }
  },
  {
    label: '手机号',
    minWidth: '150',
    prop: 'mobile',
    customRender(h, row) {
      return (
          <p class="one-line" title={row['mobile']}>
            {row['mobile']}
          </p>
      )
    }
  },
  {
    label: '角色',
    width: '120',
    prop: 'roleName',
    customRender(h, row) {
      return <p class="one-line">{row['role']?.['roleName']}</p>
    }
  },
  {
    label: '部门',
    minWidth: '120',
    prop: 'dept',
    customRender(h, row) {
      return <div>{row['dept']?.['deptName']}</div>
    }
  },
  {
    label: '状态',
    prop: 'status',
    minWidth: '120',
    customRender(h, row) {
      return (
          <div>
            <el-switch
                class="switch"
                onChange={() => this.changeStatus(row)}
                disabled={row['isSuper'] || !this.isShowBtn(this.AUTH_BTN.user_list_status)}
                v-model={row['status']}
                active-value={true}
                inactive-value={false}
                active-text="启用"
                inactive-text="禁用"
            ></el-switch>
          </div>
      )
    }
  },
  {
    label: '性别',
    minWidth: '80',
    prop: 'genderName',
    customRender(h, row) {
      return <div>{row['genderName']}</div>
    }
  },
  {
    label: '创建时间',
    minWidth: '180',
    prop: 'createTime',
    customRender(h, row) {
      return (
          <p class="one-line" title={row['createTime']}>
            {row['createTime']}
          </p>
      )
    }
  },
  {
    label: '操作',
    fixed: 'right',
    minWidth: '120',
    customRender(h, row) {
      return (
          <div>
            <el-link
                v-show={this.isShowBtn(this.AUTH_BTN.user_list_edit)}
                disabled={row['isSuper'] == 1}
                underline={false}
                type="primary"
                onClick={() => {
                  this.showAddOrEdit = true;
                  this.rowId = row["id"];
                }}
            >
              编辑
            </el-link>

            <el-link
                v-show={this.isShowBtn(this.AUTH_BTN.user_list_del)}
                disabled={row['isSuper'] == 1}
                underline={false}
                style="margin:0 10px"
                type="danger"
                onClick={() => this.goRemove(row['id'])}
            >
              删除
            </el-link>
          </div>
      )
    }
  }
];

export default {
  name: 'SystemUserList',
  mixins: [authBtnMixin],
  components: { SelectDept, SelectRole, AddOrEdit },
  data() {
    return {
      dialogVisible: false,
      isShow: false,
      list: [],
      pageSize: 10,
      defaultProps: {
        children: 'children',
        label: 'deptName'
      },
      searchData: {
        userName: '',
        mobile: '',
        roleId: '',
        deptId: '',
        jobId: ''
      },
      total: 0,
      currentPage: 1,
      columns,
      roleList: [],
      treeData: [],
      currentDept: {}, //树形的每项数据
      rowId: null,
      showAddOrEdit: false,
    }
  },
  provide() {
    return {
      context: this
    }
  },
  watch: {
    currentPage() {
      this.getAdminList();
    },
    pageSize() {
      this.getAdminList();
    },
    treeData: {
      handler() {
        if (this.treeData.length > 0 && !this.currentDept.id) {
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.treeData[0].id);
            this.currentDept = this.$refs.tree.getCurrentNode();
            this.getAdminList();
          })
        }
      }
    },
    'searchData.deptId': {
      handler(newV, oldV) {
        this.$refs.tree.setCurrentKey(newV);
        this.getAdminList();
      }
    }
  },

  mounted() {
    this.getRoleList();
    this.getDeptTree();
  },

  methods: {
    async getRoleList() {
      let params = { page: 1, pageSize: 50 };
      const res = await getRoleList(params);
      this.roleList = res.list || [];
    },
    async getAdminList() {
      const { userName, mobile, roleId, jobId } = this.searchData;
      const { id } = this.currentDept;
      let params = { userName, mobile, roleId, deptId: id, jobId, page: this.currentPage, pageSize: this.pageSize };
      let res = await getAdminList(params);
      this.list = res?.list || [];
      this.total = res?.total || 0;
    },
    async goRemove(id) {
      this.$confirm('确定要删除该员工吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            removeAdmin({ id }).then(() => {
              this.$message.success('删除成功');
              this.getAdminList();
            })
          })
          .catch(() => {})
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData);
      this.getAdminList();
    },
    changeStatus(row) {
      let { id, status } = row;
      let data = { id, status };
      let statusDesc = status ? '启用' : '禁用';

      this.$confirm(`确定要${statusDesc}该员工吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            row.status = status;
            changeStatus(data).then(() => {
              this.getAdminList();
              this.$message.success('操作成功');
            })
          })
          .catch(() => {
            row.status = !status;
          })
    },
    async getDeptTree() {
      const res = await getDeptTree();
      this.treeData = res || [];
      this.$nextTick(() => {
        this.currentDept = this.$refs.tree.getCurrentNode();
      })
    },
    handleNodeClick(data, node) {
      this.currentDept = data;
      this.getAdminList();
    },
    // 关闭弹框
    closeDialogFun(flag) {
      this.showAddOrEdit = false;
      if (flag) {
        this.getAdminList();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
  .header-search {
    .el-form /deep/ {
      .el-form-item {
        margin-right: 35px;
      }
    }
  }
  .el-divider--horizontal {
    margin: 0 0 20px;
  }
  /* switch按钮样式 */
  .switch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }
  /*打开时文字位置设置*/
  .switch .el-switch__label--right {
    z-index: 1;
  }
  /* 调整打开时文字的显示位子 */
  .switch .el-switch__label--right span {
    margin-left: 5px;
  }
  /*关闭时文字位置设置*/
  .switch .el-switch__label--left {
    z-index: 1;
  }
  /* 调整关闭时文字的显示位子 */
  .switch .el-switch__label--left span {
    margin-left: 20px;
  }
  /*显示文字*/
  .switch .el-switch__label.is-active {
    display: block;
  }
  /* 调整按钮的宽度 */
  .switch.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 55px !important;
    margin: 0;
  }
}
</style>
<style lang="scss" scoped>
.wrapper {
  .container {
    display: flex;
    height: calc(100% - 23px);
    .left {
      border-right: 1px solid #ccc;
      margin-right: 20px;
      .el-cascader {
        min-width: 200px;
        max-width: 300px;
        margin: 10px;
      }
      .tree {
        min-width: 200px;
        max-width: 300px;
        .el-tree /deep/ {
          .el-tree-node__content {
            height: 40px;
            .el-tree-node__expand-icon {
              margin-left: 20px;
            }
          }
          .el-tree-node.is-current > .el-tree-node__content {
            background-color: #e6f7ff;
            border-right: 3px solid #1890ff;
            .el-tree-node__label,
            .el-tree-node__expand-icon {
              color: #1890ff;
            }
            .el-tree-node__expand-icon.is-leaf {
              color: transparent !important;
            }
          }
        }
      }
    }
    .right {
      min-width: 800px;
    }
  }
}
</style>
